// Canonical public URL for sharing — always points to the production app,
// never to the preview environment, so links forwarded via WhatsApp / iMessage
// / email take strangers straight to myworld.quest.
//
// `REACT_APP_PUBLIC_URL` can override this in environments that aren't the
// real production app (e.g. staging clones). Defaults to the canonical
// production URL so every shared link is brand-correct.

export const PUBLIC_URL = (process.env.REACT_APP_PUBLIC_URL || "https://myworld.quest").replace(/\/+$/, "");

export function shareUrl(path = "/") {
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${PUBLIC_URL}${p}`;
}
